

































import { Component, Vue, Prop } from "vue-property-decorator";
import PicPreview from "@/components/pic-preview.vue";
@Component({
  components: {
    PicPreview
  }
})
export default class IdrShouJiqi extends Vue {
  @Prop()
  private current: any;
  private ifShowPicPreview: boolean = false;
  private picUrl: any = "";
  /**
   * @description 打开预览图
   */
  private showPreview(url) {
    this.picUrl = url;
    this.ifShowPicPreview = true;
  }
}
